import React from 'react';
import './DifficultyPill.scss';

const DifficultyPill = ({ difficultyScore, dictionary }) => {
  const getDifficultyLabel = (score) => {
    if (score <= 0.5) {
      return {
        label: dictionary.easy,
        className: 'easy',
      };
    } else if (score <= 0.8) {
      return {
        label: dictionary.medium,
        className: 'medium',
      };
    } else {
      return {
        label: dictionary.hard,
        className: 'hard',
      };
    }
  };

  const { label, className } = getDifficultyLabel(difficultyScore);

  return (
    <div className="c-difficulty-pill-wrapper">
      <div className={`c-difficulty-pill c-difficulty-pill--${className}`}>{label}</div>
    </div>
  );
};

export default DifficultyPill;
